import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box, Tooltip, Typography } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { makeStyles } from "@material-ui/core/styles";
import { rateCourse } from "../../../actions/courses";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  star: {
    cursor: "pointer",
    fontSize: 28,
    color: "#c9a227",
    transition: "transform 0.1s",
    "&:hover": {
      transform: "scale(1.15)",
    },
  },
  ratingLabel: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 13,
  },

}));

const StarRating = ({ course, user }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const ratings = course?.ratings || [];
  const avgRating =
    ratings.length > 0
      ? ratings.reduce((sum, r) => sum + r.value, 0) / ratings.length
      : 0;

  const userId = user?.result?._id;
  const userRating = userId
    ? ratings.find((r) => r.userId === String(userId))?.value ?? 0
    : 0;

  const history = useHistory();
  const [hovered, setHovered] = useState(0);

  const handleRate = (value) => {
    if (!userId) {
      history.push("/auth");
      return;
    }
    dispatch(rateCourse(course._id, value));
  };

  const displayValue = hovered || userRating;

  return (
    <Box>
      <Box className={classes.container}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Tooltip
            key={star}
            title={userId ? `Rate ${star} star${star !== 1 ? "s" : ""}` : "Sign in to rate this course"}
            placement="top"
          >
            <span
              onMouseEnter={() => userId && setHovered(star)}
              onMouseLeave={() => setHovered(0)}
              onClick={() => handleRate(star)}
            >
              {star <= displayValue ? (
                <StarIcon className={classes.star} />
              ) : (
                <StarBorderIcon className={classes.star} style={{ color: "#c9a227" }} />
              )}
            </span>
          </Tooltip>
        ))}
        {ratings.length > 0 && (
          <Typography className={classes.ratingLabel}>
            {avgRating.toFixed(1)} / 5 &nbsp;({ratings.length} rating{ratings.length !== 1 ? "s" : ""})
          </Typography>
        )}
      </Box>

    </Box>
  );
};

export default StarRating;
